import { tv } from 'tailwind-variants'
import { cn } from '@scalis/utils'
import { ButtonKind } from '../button.types'
import { baseButton } from './base-button.styles'

export const buttonClassName = tv({
  extend: baseButton,
  base: 'text-center disabled:bg-button-disabled disabled:text-neutral-disabled',
  variants: {
    rounded: {
      true: 'rounded-xl',
      false: 'rounded-none',
    },
    kind: {
      [ButtonKind.combobox]: cn('bg-neutral-00', 'hover:bg-neutral-10 text-sm text-neutral-tertiary'),
      [ButtonKind.primary]: cn(
        'bg-button-brand-primary-dark-rest',
        'hover:bg-button-brand-primary-dark-hover',
        'active:bg-button-brand-primary-dark-pressed',
        'text-neutral-on-brand',
      ),
      [ButtonKind.secondary]: cn(
        'bg-button-subtle-rest',
        'hover:bg-button-subtle-hover',
        'active:bg-button-subtle-pressed',
        'border border-solid border-neutral-10',
        'disabled:border-neutral-disabled disabled:bg-button-subtle-rest',
      ),
      [ButtonKind.tertiary]: cn(
        'bg-button-brand-primary-light-rest',
        'hover:bg-button-brand-primary-light-hover',
        'active:bg-button-brand-primary-light-pressed',
        'text-brand-primary-rest',
      ),
      [ButtonKind.neutral]: cn(
        'bg-transparent',
        'hover:bg-button-brand-primary-light-hover',
        'active:bg-button-brand-primary-light-pressed',
        'text-brand-primary-rest',
      ),
      [ButtonKind.critical]: cn(
        'bg-button-status-critical-rest',
        'hover:bg-button-status-critical-hover',
        'active:bg-button-status-critical-pressed',
        'text-neutral-on-brand',
      ),
      [ButtonKind.orange]: cn(
        'bg-button-orange-rest',
        'hover:bg-button-orange-hover',
        'active:bg-button-orange-pressed',
        'disabled:bg-button-orange-rest disabled:opacity-50',
        'text-dataviz-orange disabled:text-dataviz-orange',
      ),
    },
  },
  defaultVariants: {
    kind: ButtonKind.primary,
  },
})

export const getButtonHoverElementStyles = (kind: ButtonKind) => {
  switch (kind) {
    case ButtonKind.primary:
      return 'bg-button-brand-primary-dark-hover'
    case ButtonKind.secondary:
      return 'bg-button-subtle-hover'
    case ButtonKind.tertiary:
    case ButtonKind.neutral:
      return 'bg-button-brand-primary-light-hover'
    case ButtonKind.critical:
      return 'bg-button-status-critical-hover'
    case ButtonKind.orange:
      return 'bg-button-orange-hover'
    case ButtonKind.combobox:
      return 'bg-neutral-10'
    default:
      return 'bg-button-brand-primary-dark-hover'
  }
}
